export default __webpack_public_path__ + "static/media/1867.234dca86.jpg";